import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页',
            titleEn: 'home'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '关于我们',
            titleEn: 'About Us'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown',
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '关于我们',
                titleEn: 'About Us'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '关于我们',
                titleEn: 'About Us'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务',
            titleEn:'Service'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态',
            titleEn:'News'
          }
        },{
          path: '/newsDetail',
          name: 'newsDetail',
          component: resolve => require(['@/view/NewsDetail'], resolve),
          meta: {
            title: '新闻详情',
            titleEn:'News Detail'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍',
            titleEn:'Company Introduction'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们',
            titleEn:'Contact Us'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务',
            titleEn:'Service Detail'
          }
        },
        {
          path: '/logisticsService',
          name: 'logisticsService',
          component: resolve => require(['@/view/LogisticsService'],resolve),
          meta: {
            title: '物流服务',
            titleEn:'Logistics Service'
          }
        },
        {
          path: '/logisticsServiceDetail/:index',
          name: 'logisticsServiceDetail',
          component: resolve => require(['@/view/LogisticsServiceDetail'],resolve),
          meta: {
            title: '物流服务',
            titleEn:'Logistics Service'
          }
        },
        {
          path: '/advantage',
          name: 'advantage',
          component: resolve => require(['@/view/Advantage'],resolve),
          meta: {
            title: '我们的优势',
            titleEn:'Advantage'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js